import type { CropRect } from '../core/types';
import { clamp } from './clamp';

/** Extract sub-rectangle from ImageData */
export function cropImageData(source: ImageData, rect: CropRect): ImageData {
  const x = clamp(Math.round(rect.x), 0, source.width);
  const y = clamp(Math.round(rect.y), 0, source.height);
  const w = clamp(Math.round(rect.width), 1, source.width - x);
  const h = clamp(Math.round(rect.height), 1, source.height - y);

  const output = new ImageData(w, h);
  const src = source.data;
  const dst = output.data;

  for (let row = 0; row < h; row++) {
    const srcOffset = ((y + row) * source.width + x) * 4;
    const dstOffset = row * w * 4;
    dst.set(src.subarray(srcOffset, srcOffset + w * 4), dstOffset);
  }

  return output;
}
